const isWeb = true;
import { request } from "@max/meituan-uni-network";
const requestDataCenter = componentRequestParams => {
    const { componentProps, requestParams, comboCallback } = componentRequestParams;
    const { uid, moduleVersion, moduleType } = componentProps;
    return new Promise((resolve, reject) => {
        var _a;
        let url = `${requestParams.devBasePath}datacenter/query/page/data`;
        const moduleParam = (_a = requestParams === null || requestParams === void 0 ? void 0 : requestParams.body) === null || _a === void 0 ? void 0 : _a.moduleParam;
        if (isWeb && (moduleParam === null || moduleParam === void 0 ? void 0 : moduleParam.token) && (moduleParam === null || moduleParam === void 0 ? void 0 : moduleParam.userId)) {
            url = `${url}?userId=${moduleParam.userId}&token=${moduleParam.token}`;
        }
        request({
            url,
            data: {
                moduleDataList: [{
                        moduleParam: requestParams.body.moduleParam,
                        moduleName: moduleType,
                        moduleVersion,
                        resultKey: componentProps.uid
                    }]
            },
            method: 'POST',
            header: {
                'Content-Type': 'application/json'
            },
            _meituan: {
                requestType: 'MRNUtils',
                mrnChannel: 'hotel'
            },
            success(res) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                if (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.status) === 0) {
                    if (comboCallback) {
                        comboCallback((_e = (_d = (_c = (_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.moduleResponseMap) === null || _d === void 0 ? void 0 : _d[uid]) === null || _e === void 0 ? void 0 : _e.moduleData);
                    }
                    resolve((_j = (_h = (_g = (_f = res === null || res === void 0 ? void 0 : res.data) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.moduleResponseMap) === null || _h === void 0 ? void 0 : _h[uid]) === null || _j === void 0 ? void 0 : _j.moduleData);
                }
                else {
                    reject(new Error('网络开小差了'));
                }
            },
            fail(error) {
                console.log('网络开小差了');
                reject(new Error('网络开小差了'));
            }
        });
    });
};
export { requestDataCenter };
